import { render, staticRenderFns } from "./MsinAddMain.vue?vue&type=template&id=3cc5389a&scoped=true&"
import script from "./MsinAddMain.vue?vue&type=script&lang=js&"
export * from "./MsinAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MsinAddMain.vue?vue&type=style&index=0&id=3cc5389a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5389a",
  null
  
)

export default component.exports